<loren-error-template
  [title]="'error_page.general_error_title' | transloco"
  [message]="'error_page.general_error_message' | transloco"
></loren-error-template>
